import React, { useState } from "react";
import {
    Tooltip, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button
} from "@heroui/react";
import { FLUTTER_INSIGHTS_URL, FLUTTER_REPORTS_URL } from "../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";

const AppSwitcher = () => {
    const [menuOpen, setMenuOpen ] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const currentPath = location.pathname;

    const links = [
        {
            label: "GPSC Insights",
            url: FLUTTER_INSIGHTS_URL,
            show: true,
            internal: false,
        },
        {
            label: "GPSC Reports",
            url: FLUTTER_REPORTS_URL,
            show: true,
            internal: false,
        },
        // {
        //     label: "GPSC Reports",
        //     url: "/report",
        //     show: currentPath !== "/report",
        //     internal: true,
        // },

    ];

    return (
        <Dropdown 
            showArrow
            onOpenChange={(isOpen) => setMenuOpen(isOpen)}
            className="z-[9999] bg-primary"
            >
            {!menuOpen && (
                <Tooltip content="Show menu" placement="bottom" className="bg-secondary" >
                    <div className="cursor-pointer">
                        <DropdownTrigger>
                            <Button isIconOnly variant="light" aria-label="App Switcher">
                                <img 
                                    src="/images/app_switcher.svg"
                                    alt="App Switcher Icon"
                                    className="w-8 h-8"
                                    />
                            </Button>
                        </DropdownTrigger>
                    </div>
                </Tooltip>
            )}

            {menuOpen && (
                <div className="cursor-default">
                     <DropdownTrigger>
                            <Button isIconOnly variant="light" aria-label="App Switcher">
                                <img 
                                    src="/images/app_switcher.svg"
                                    alt="App Switcher Icon"
                                    className="w-8 h-8"
                                    />
                            </Button>
                        </DropdownTrigger>
                </div>
            )}

            <DropdownMenu
                aria-label="App Switcher Menu"
                className="bg-primary text-white min-w-[200px]"
                >

                    {links
                        .filter((link) => link.show)
                        .map((link) => (
                        <DropdownItem 
                            key={link.label}
                            href={link.internal ? undefined : link.url }
                            onPress={() => {
                                if (link.internal) navigate(link.url);
                            }}
                            target={link.internal ? undefined : "_blank" }
                            rel={link.internal ? undefined : "noopener noreferrer" }
                            className="text-white"
                            startContent={
                                <img 
                                    src="/images/launchIcon.svg"
                                    alt="launch"
                                    className="w-4 h-4"
                                />

                            }
                            >
                                {link.label}
                            </DropdownItem>

                    ))}
                </DropdownMenu>
            </Dropdown>
    )
}

export default AppSwitcher;